import React, { Component } from 'react'
import 'bootstrap/dist/css/bootstrap.css';
import { CardDeck, Row, Col, Container, Card } from 'react-bootstrap'

class BannerSideBox extends React.Component {
    constructor(props) {
        super(props);

    }

    render() {
        return (
             <Card style={{textAlign:'left'}}>
                 <Card.Title className="card-header">
                          <span style={{marginBottom:'10px'}}> <strong>Account Mapping Overview</strong></span>
                          <small>Tracking Company: TPL</small>
                 </Card.Title>
                 <Card.Body className="pt-0" style={{padding:'1.5rem'}}>   
                          <p>
                          There are a total of <span id="no">{this.props.noOfFuelSensor}</span> Vehicles mapped to <span id="no">{this.props.noOfMappedCards + " "}
                          </span> 
                           Shell Cards in your account <span id="no"> {this.props.AccountNo} </span>
                          </p>
                         <a href='./ManageShellCard'>Click here to map the remaining <span id="no">{this.props.remaning}</span> Shell Cards</a>
                 </Card.Body>
             </Card> 
        );
      }
  }
export default BannerSideBox;